import { ServicesData } from './../../services/services.data';
import { PageHeadingService } from './../../components/page-heading/page-heading.svc';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormGroup, FormArray, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Location } from '@angular/common';

import { RegistrationsData } from './../registrations.data';
import { Registration } from './registration';


@Component({

  selector: 'registration-edit',
  templateUrl: './registration-edit.tmpl.html'
})


export class RegistrationEdit implements OnInit {
  constructor(
    public router: Router,
    private activatedRoute: ActivatedRoute,
    private registrationsData: RegistrationsData,
    private formBuilder: FormBuilder,
    private location: Location,
    public servicesData: ServicesData
  ) {

  }

  isAronit: boolean = false;;
  registration: Registration;
  id: number;
  contactId: number;
  payMethods: any;
  payOption = '';
  registrationForm: FormGroup;

  public load(): void {
    if (this.id > 0) {
      this.registrationsData.getEdit(this.id)
        .subscribe((p: any) => {
          this.registration = p;
          this.loadEventType(this.registration.registrationEventID)
          this.fillForm(p);
        });
    }
    else {
      this.registrationsData.getAdd(this.contactId)
        .subscribe((p: any) => {
          this.registration = p;
          this.fillForm(p);
        });
    }
  }

  private fillForm(p: Registration): void {
    this.registrationForm.patchValue(p);
    this.getPayMethods(); //הועבר לכאן כדי שיטען לאחר טעינת ה-contactID
  }

  public save(): void {
    console.log('save run');
    if (this.registrationForm.valid) {
      this.registrationsData.update(this.registrationForm.value)
        .subscribe((c: any) => {
          this.location.back();
        },
          error => { });
    } else {
      console.log('not valid');
      console.log(this.registrationForm.errors);
    }
  }


  public cancel(): void {
    this.location.back();
  }


  payMethodsAddEvent(payMethod) {
    this.registrationForm.controls['commitmentPayMethodID'].setValue(payMethod.id);
    this.setPayOption(payMethod.id, payMethod.type);
  }
  payMethodsChangeEvent(payMethod) {
    this.registrationForm.controls['commitmentPayMethodID'].setValue(payMethod.id);
    this.setPayOption(payMethod.id, payMethod.type);
  }


  loadEventType(e) {
    this.registrationsData.getEventType(e).subscribe(x => {
      if (x == 4) {
        this.isAronit = true;
      } else {
        this.isAronit = false;
        this.registrationForm.controls['aronitNumber'].setValue(null);
      }
    }
    );
  }

  setPayOption(payMethodID: number, payMethodOption: string = null) {
    if ([88, 89, 420, 1310, 3580, 6232, 6990, 42340, 47080].indexOf(payMethodID) == -1) {
      switch (payMethodOption) {
        case 'אשראי':
          this.payOption = 'cc';
          break;
        case 'הוראת קבע':
          this.payOption = 'hok';
          break;
        default:
          break;
      }
    }
    else if (payMethodID == 88) {
      this.payOption = 'Cash';
    }
    else if (payMethodID == 89) {
      this.payOption = 'Check';
    }
    else if (payMethodID == 420) {
      this.payOption = 'BankTransfer';
    }
    else if (payMethodID == 1310) {
      this.payOption = 'cashRegister';
    }
    else if (payMethodID == 3580) {
      this.payOption = 'voucher';
    }
    else if (payMethodID == 6232) {
      this.payOption = 'externalSoftware';
    }
    else if (payMethodID == 6990) {
      this.payOption = 'moneyValue';
    }
    else if (payMethodID == 47080) {
      this.payOption = 'externalCreditCard';
    }
    else if (!payMethodID || payMethodID == 0) {
      this.payOption = '';
    }
  }






  private initForm() {
    this.registrationForm = this.formBuilder.group({
      createBy: [], createDate: [], changeBy: [], changeDate: [],
      registrationID: [this.id, Validators.required],
      contactID: [this.contactId, Validators.required],
      contactName: [],
      registrationEventID: [null, Validators.required],
      registrationEventTitle: [],
      quantity: [, Validators.required],
      payMethodID: [null],
      registeringPhone: [],
      callerNumber: [],
      aronitNumber: []

    });

  }



  public getPayMethods(): void {
    let cid = this.contactId > 0 ? this.contactId : this.registration.contactID;
    let pmID = this.registrationForm.controls['payMethodID'].value;
    this.servicesData.getList(`PayMethods/${cid}/${false}/${pmID}`).subscribe(
      c => this.payMethods = c,
      error => { });
  }

  ngOnInit() {
    this.activatedRoute.params.forEach((params: Params) => {
      this.id = +params['registrationID'] || 0;
      this.contactId = +params['contactID'] || 0;
    });

    console.log(this.activatedRoute.params);
    this.initForm();
    this.load();
  }
}



